<template>
    <PodcastPlayer v-if="this.selected" class="mb-2"
        :podcast="this.selected"
        :hideSidebar="true" />
</template>

<script>
import utils from "@/mixins/utils";
import uploads from "@/mixins/uploads";
import API from "@/API";
import {mapActions} from "vuex";
import PodcastPlayer from '@/Components/Podcast2/PodcastPlayer'

export default {
    name: "InLinePodcast",
    // components: {},
    components: {PodcastPlayer},
    mixins: [utils, uploads],

    emits: ['remove-resource'],
    props: ['element', 'stage', 'path', 'canvas', 'section', 'editable'],


    data(){
        return {

            is_busy: false,
            selected: null,

            change_modal: {
                is_ready: false,
                show: false,
                search: '',
                podcasts: [],
                podcast_actions: {
                    select: {
                        class: 'btn-light',
                        title: 'Select',
                        action: (podcast) => this.selectPodcast(podcast),
                    }
                }
            },

            preview_modal: {
                show: false,
            }
        }
    },


    computed: {

        can_edit(){
            return this.editable && !this.podcast_is_in_path;
        },

        path_fragment_key(){
            return `stage_${this.stage}_${this.section.id}_podcast_${this.element?.id}`;
        },

        canvas_fragment_key(){
            return `stage_${this.stage}_${this.section.id}_podcast_${this.element?.id}`;
        },

        path_podcast_data(){
            return this.path?.fragments[ this.path_fragment_key ] ? this.path.fragments[ this.path_fragment_key ] : null;
        },

        canvas_podcast_data(){
            return this.canvas?.fragments[ this.canvas_fragment_key ] ? this.canvas.fragments[ this.canvas_fragment_key ] : null;
        },

        podcast_is_in_path(){
            return !!this.path_podcast_data;
        },

        podcast_is_in_canvas(){
            return !!this.canvas_podcast_data;
        },

        has_podcast(){
            return this.podcast_is_in_path || this.podcast_is_in_canvas;
        },

        podcast_data(){

            /**
             * Priority: First check in path, then in canvas
             */

            if( this.podcast_is_in_path ){
                return this.path_podcast_data;
            }else if( this.podcast_is_in_canvas ){
                return this.canvas_podcast_data;
            }

            return false;
        },

        resource(){
            return this.element?.element ? this.element.element : null;
        },

        change_modal_filtered_podcasts(){
            if( !this.change_modal.search.length ) return this.change_modal.podcasts;
            const regex = new RegExp(this.change_modal.search, 'gi');
            return this.change_modal.podcasts.filter(p => regex.test(p.name) || regex.test(p.description));
        },

        podcast_name(){
            return this.selected?.name ? this.selected.name : 'Choose a DFC podcast';
        },

        options(){
            return this.resource?.data?.options;
        },

        background_color(){
            try{ return this.resource.data.color; } catch (e){};
            return '#343a40';
        },

        preview_url_optimized(){
            let w = this.options?.width;
            w = w ? w * 320 : 320;
            return this.uploads.image(this.preview_url, {w, h: 320});
        },

        preview_url(){
            return this.selected?.picture_large ? this.selected?.picture_large : this.resource.data.file.url;
        },
    },

    async beforeMount() {
        this.is_busy = true;

        if( this.has_podcast && this.podcast_data?.podcast?.short_name ){
            this.selected = await API.podcasts.get( this.podcast_data?.podcast?.short_name );
        }

        this.is_busy = false;
    }

}
</script>